export default {

  data() {
      return {
        tempIds: [],
        tempIdsl: [],
        st: [],
        lt: [],
        check: '',

      }

    },
    props: ['source', 'heading', 'keys', 'value'],
    watch: {
      value: function() {
        this.watchArray(this.value, this.lt)

      },

      lt: function() {
        this.watchArray(this.lt, this.value)
      }

    },
    mounted() {
      let context = this

      this.source.map(function(item) {

        context.lt.push(item)
      })
      this.watchArray(this.value, this.lt)
    },

    methods: {
      remove() {
          this.value.splice(0, 1)

        },
        pushLeft() {
          let context = this
          this.tempIdsl.map(function(item, index) {
              context.lt.push(item)

            })
            // $('.el-checkbox__input').removeClass('is-checked')
            // $('.el-checkbox__input').addClass('is-focus')
          $('.check').prop('checked', false);
          this.temspIdsl = []


        },
        pushRight() {
          let context = this
          this.tempIds.map(function(item, index) {
            context.value.push(item)
          })
          $('.check').prop('checked', false);
          this.tempIds = []

        },
        tempPushl(item1) {

          let context = this


          var removeIndex = context.tempIdsl.map(function(item) {
            return item.Id;
          }).indexOf(item1.Id);

          if (removeIndex < 0) {
            this.tempIdsl.push(item1)
          } else {
            context.tempIdsl.splice(removeIndex, 1);
          }



        },
        tempPush(item1) {

          let context = this

          var removeIndex = context.tempIds.map(function(item) {
            return item.Id;
          }).indexOf(item1.Id);

          if (removeIndex < 0) {
            this.tempIds.push(item1)
          } else {
            context.tempIds.splice(removeIndex, 1);
          }



        },

        watchArray(val1, val2) {
          let context = this
          val1.map(function(item1, index) {
            var removeIndex = val2.map(function(item) {
              return item.Id;
            }).indexOf(item1.Id);
            if (removeIndex > -1) {
              val2.splice(removeIndex, 1);

            }


          })



        }


    },



}



// WEBPACK FOOTER //
// ./src/components/transfer/transfer.controller.js